/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AggregateKeyInfo } from './AggregateKeyInfo';
import {
    AggregateKeyInfoFromJSON,
    AggregateKeyInfoFromJSONTyped,
    AggregateKeyInfoToJSON,
} from './AggregateKeyInfo';
import type { DateSearch } from './DateSearch';
import {
    DateSearchFromJSON,
    DateSearchFromJSONTyped,
    DateSearchToJSON,
} from './DateSearch';
import type { TextSearch } from './TextSearch';
import {
    TextSearchFromJSON,
    TextSearchFromJSONTyped,
    TextSearchToJSON,
} from './TextSearch';

/**
 * 
 * @export
 * @interface SmsSearch
 */
export interface SmsSearch {
    /**
     * 
     * @type {number}
     * @memberof SmsSearch
     */
    idApprenant?: number | null;
    /**
     * 
     * @type {number}
     * @memberof SmsSearch
     */
    idFormateur?: number | null;
    /**
     * 
     * @type {TextSearch}
     * @memberof SmsSearch
     */
    message?: TextSearch;
    /**
     * 
     * @type {DateSearch}
     * @memberof SmsSearch
     */
    dateEnvoi?: DateSearch;
    /**
     * 
     * @type {TextSearch}
     * @memberof SmsSearch
     */
    statut?: TextSearch;
    /**
     * 
     * @type {TextSearch}
     * @memberof SmsSearch
     */
    anneeScolaire?: TextSearch;
    /**
     * 
     * @type {Array<string>}
     * @memberof SmsSearch
     */
    sortKey?: Array<string> | null;
    /**
     * 
     * @type {Array<AggregateKeyInfo>}
     * @memberof SmsSearch
     */
    aggregateKeys?: Array<AggregateKeyInfo> | null;
    /**
     * 
     * @type {number}
     * @memberof SmsSearch
     */
    forceSkip?: number | null;
    /**
     * 
     * @type {number}
     * @memberof SmsSearch
     */
    forceTake?: number | null;
    /**
     * 
     * @type {any}
     * @memberof SmsSearch
     */
    parameters?: any | null;
    /**
     * 
     * @type {string}
     * @memberof SmsSearch
     */
    filter?: string | null;
}

/**
 * Check if a given object implements the SmsSearch interface.
 */
export function instanceOfSmsSearch(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function SmsSearchFromJSON(json: any): SmsSearch {
    return SmsSearchFromJSONTyped(json, false);
}

export function SmsSearchFromJSONTyped(json: any, ignoreDiscriminator: boolean): SmsSearch {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'idApprenant': !exists(json, 'idApprenant') ? undefined : json['idApprenant'],
        'idFormateur': !exists(json, 'idFormateur') ? undefined : json['idFormateur'],
        'message': !exists(json, 'message') ? undefined : TextSearchFromJSON(json['message']),
        'dateEnvoi': !exists(json, 'dateEnvoi') ? undefined : DateSearchFromJSON(json['dateEnvoi']),
        'statut': !exists(json, 'statut') ? undefined : TextSearchFromJSON(json['statut']),
        'anneeScolaire': !exists(json, 'anneeScolaire') ? undefined : TextSearchFromJSON(json['anneeScolaire']),
        'sortKey': !exists(json, 'sortKey') ? undefined : json['sortKey'],
        'aggregateKeys': !exists(json, 'aggregateKeys') ? undefined : (json['aggregateKeys'] === null ? null : (json['aggregateKeys'] as Array<any>).map(AggregateKeyInfoFromJSON)),
        'forceSkip': !exists(json, 'forceSkip') ? undefined : json['forceSkip'],
        'forceTake': !exists(json, 'forceTake') ? undefined : json['forceTake'],
        'parameters': !exists(json, 'parameters') ? undefined : json['parameters'],
        'filter': !exists(json, 'filter') ? undefined : json['filter'],
    };
}

export function SmsSearchToJSON(value?: SmsSearch | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'idApprenant': value.idApprenant,
        'idFormateur': value.idFormateur,
        'message': TextSearchToJSON(value.message),
        'dateEnvoi': DateSearchToJSON(value.dateEnvoi),
        'statut': TextSearchToJSON(value.statut),
        'anneeScolaire': TextSearchToJSON(value.anneeScolaire),
        'sortKey': value.sortKey,
        'aggregateKeys': value.aggregateKeys === undefined ? undefined : (value.aggregateKeys === null ? null : (value.aggregateKeys as Array<any>).map(AggregateKeyInfoToJSON)),
        'forceSkip': value.forceSkip,
        'forceTake': value.forceTake,
        'parameters': value.parameters,
        'filter': value.filter,
    };
}

